import { render, staticRenderFns } from "./addBaseInfo.vue?vue&type=template&id=72c05aeb&scoped=true&"
import script from "./addBaseInfo.vue?vue&type=script&lang=js&"
export * from "./addBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./addBaseInfo.vue?vue&type=style&index=0&id=72c05aeb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c05aeb",
  null
  
)

export default component.exports